"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.braintreeConstants = exports.braintreeState = exports.paypalConstants = exports.paypalState = exports.actionTypes = exports.expressPayContext = exports.showPaymentMethodTypes = exports.showPaymentMethods = void 0;
exports.showPaymentMethods = {
    stripe: false,
    paypal: false,
    braintreeGoogle: false,
    braintreeApple: false
};
exports.showPaymentMethodTypes = {
    STRIPE: 'stripe',
    PAYPAL: 'paypal',
    BRAINTREE_GOOGLE: 'braintreeGoogle',
    BRAINTREE_APPLE: 'braintreeApple'
};
exports.expressPayContext = {
    onAction: null
};
exports.actionTypes = {
    ENABLE_DISABLE_SECTION: 'ENABLE_DISABLE_SECTION',
    ORDER_COMPLETED: 'ORDER_COMPLETED',
    ORDER_PROCESSING: 'ORDER_PROCESSING',
    DISPLAY_ERROR: 'DISPLAY_ERROR',
};
exports.paypalState = {
    paypal: null,
    gatewayPublicId: ''
};
exports.paypalConstants = {
    MAX_SHIPPING_OPTIONS_LENGTH: 10,
    MAX_STRING_LENGTH: 127,
};
exports.braintreeState = {
    braintree: null,
    googlePayClient: null,
    googlePayInstance: null,
    appleInstance: null,
    appleSession: null,
    googleCredentials: null,
    appleCredentials: null
};
exports.braintreeConstants = {
    BASE_JS_URL: 'https://js.braintreegateway.com/web',
    GOOGLE_JS_URL: 'https://pay.google.com/gp/p/js/pay.js',
    CLIENT_JS: 'js/client.min.js',
    APPLE_JS: 'js/apple-pay.min.js',
    GOOGLE_JS: 'js/google-payment.min.js',
    DATA_COLLECTOR_JS: 'js/data-collector.min.js',
    JS_VERSION: '3.88.2',
    APPLEPAY_VERSION_NUMBER: 3,
    APPLEPAY_ERROR_CODE_SHIPPING_CONTACT: 'shippingContactInvalid',
    APPLEPAY_ERROR_CODE_BILLING_CONTACT: 'billingContactInvalid',
    APPLEPAY_ERROR_CODE_UNKNOWN: 'unknown',
    GOOGLEPAY_ERROR_REASON_SHIPPING: 'SHIPPING_ADDRESS_INVALID',
    GOOGLEPAY_ERROR_REASON_PAYMENT: 'PAYMENT_DATA_INVALID',
    GOOGLEPAY_TRANSACTION_STATE_SUCCESS: 'SUCCESS',
    GOOGLEPAY_TRANSACTION_STATE_ERROR: 'ERROR',
    GOOGLEPAY_INTENT_SHIPPING_ADDRESS: 'SHIPPING_ADDRESS',
    GOOGLEPAY_INTENT_SHIPPING_OPTION: 'SHIPPING_OPTION',
    GOOGLEPAY_INTENT_PAYMENT_AUTHORIZATION: 'PAYMENT_AUTHORIZATION',
    GOOGLEPAY_TRIGGER_INITIALIZE: 'INITIALIZE',
    GOOGLEPAY_VERSION_NUMBER: 2,
    GOOGLEPAY_VERSION_NUMBER_MINOR: 0,
};
